import { CompletionConfidence } from '../../../../shared/components/CompletionConfidence';
import { PurposeMajorPurchase } from '../../../data';

type Props = {
  purpose: PurposeMajorPurchase;
};

export const MajorPurchaseHeader = ({ purpose }: Props) => {
  const completion = purpose.majorPurchaseProjection?.completion;

  if (!completion) return null;

  return <CompletionConfidence {...completion} />;
};
